import Head from 'next/head';
import { useRouter } from "next/router";

import CityDetailsComponent from "../../components/CityDetailsComponent/CityDetailsComponent"
import { NextHead } from "../../components/NextHead/NextHead";
import { _fetchCmsPageData, _fetchFooterCmsData } from "../../helper/service";
import { AxiosInstance } from "../../utilities";


export default function CityDetails(props) {
  const router = useRouter();

  const { slug } = router.query;
  if (!router.isReady) {
    return null;
  }

  let seo = props.seo || {};
  

  return (
    <>
      <NextHead {...(seo ?? {})}/>
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/cities/${slug}`} />
      </Head>
      <CityDetailsComponent slug={slug} {...props} />
    </>
  );
}

export async function getServerSideProps(context) {
  let seo = {};
  let notFound = false;

  // Fetch city details
  await AxiosInstance(4008, "application/json")
    .get(`/city/${context.query.slug}`)
    .then((resp) => {
      const response = resp?.data;
      if (response?.status === 200) {
        seo = response?.detail?.[0]?.seo ?? {};
      } else if (response?.status === 404) {
        notFound = true;
      }
    });

  const footerData = await _fetchFooterCmsData();

  return { props: { footerData, seo }, notFound };
}
